/**
 * ByteTrack / ByTrack 在线客服（统一入口）
 * SDK 在 public/index.html 中通过 UMD 引入并初始化（含 groupId，支持分组/坐席）。
 * 文档：https://docs.bytrack.com/8CTFE8cF/developers/wikidetail?articleId=HVCFEAIIlJ&usageCategoryId=443
 */

const CS_APP_ID = 'r6OSYrOT';
const CS_HOST = 'https://msg.btcuax.top';
const CS_GROUP_ID = 'HLSQeMy7D2';

function getByteTrack() {
  if (typeof window === 'undefined') return null;
  return window.bytetrack || null;
}

function waitForByteTrackReady(timeoutMs) {
  var BT = getByteTrack();
  if (BT && BT.instance) return Promise.resolve(BT);
  return new Promise(function (resolve, reject) {
    var start = Date.now();
    var id = setInterval(function () {
      var cur = getByteTrack();
      if (cur && cur.instance) {
        clearInterval(id);
        resolve(cur);
        return;
      }
      if (Date.now() - start > timeoutMs) {
        clearInterval(id);
        reject(new Error('ByteTrack SDK not ready'));
      }
    }, 80);
  });
}

function mapLang(locale) {
  var l = String(locale || 'en').toLowerCase();
  if (l.startsWith('zh')) return 'zh_CN';
  return 'en_US';
}

function getUserId(vm) {
  var user = vm && vm.$store && vm.$store.getters && vm.$store.getters.getUserInfo;
  if (!user || user.id === undefined || user.id === null || user.id === '') return '';
  return String(user.id);
}

/**
 * @param {import('vue').default} vm 组件实例（this），用于 $store / $i18n / $message
 */
export function openCustomerService(vm) {
  if (!vm) return;

  var lang = mapLang(
    (vm.$store && vm.$store.state && vm.$store.state.currentLanguage) ||
      (vm.$i18n && vm.$i18n.locale)
  );
  var userId = getUserId(vm);

  waitForByteTrackReady(15000)
    .then(function (BT) {
      BT.setLanguage(lang);
      BT.userLogin({ userId: userId });
      BT.setMsgVisible(true);
    })
    .catch(function (err) {
      console.error('ByteTrack customer service error:', err);
      var msg =
        (vm.$i18n && vm.$t && vm.$t('customerService.error')) ||
        'Customer support is temporarily unavailable. Please try again later.';
      if (vm.$message) vm.$message.error(msg);
    });
}

export { CS_APP_ID, CS_HOST, CS_GROUP_ID };
